import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {fetchLivePorfolio} from '../screens/portfolio/redux/portfolio.action';
import {clearContestData} from '../utils/live/actions';

export function useInitialiseSocketConnection(
  ws,
  isAppLogin,
  contestId,
  isCallNormal = true,
) {
  let wsConnected = useSelector(({liveReducer}) => liveReducer.connected);

  const dispatch = useDispatch();

  useEffect(() => {
    !contestId ? fetchPortfolio() : fetchPortfolioContest();
  }, []);

  const fetchPortfolio = async () => {
    const token = await AsyncStorage.getItem('token');
    setTimeout(() => {
      token && isCallNormal && dispatch(fetchLivePorfolio(null, token));
    }, 0);
  };

  const fetchPortfolioContest = async () => {
    const token = await AsyncStorage.getItem('token');
    setTimeout(() => {
      token && contestId && dispatch(fetchLivePorfolio(contestId, token));
    }, 0);
  };

  const subscribeToEvents = async () => {
    try {
      const token = await AsyncStorage.getItem('token');
      if (token) {
        if (contestId) {
          dispatch(clearContestData());
          ws.send(
            JSON.stringify({
              topic: `fantasy-price-ticks`,
              action: 'subscribe',
              token,
            }),
          );
        }
        if (!contestId) {
          ws.send(
            JSON.stringify({
              topic: `portfolio-im-fixed`,
              action: 'subscribe',
              token,
            }),
          );
          ws.send(
            JSON.stringify({
              topic: `portfolio-im-variable`,
              action: 'subscribe',
              token,
            }),
          );
        }

        ws.send(
          JSON.stringify({
            topic: contestId
              ? `fantasy-private-portfolio`
              : `private-portfolio`,
            action: 'subscribe',
            token,
            contestId,
          }),
        );
      }
    } catch (e) {}
  };

  useEffect(() => {
    if (wsConnected === 1 && ws) {
      subscribeToEvents();
    }
    return () => {
      if (wsConnected === 1 && ws) {
        try {
          if (contestId) {
            ws.send(
              JSON.stringify({
                topic: `fantasy-price-ticks`,
                action: 'unsubscribe',
                token,
              }),
            );
          }
          if (!contestId) {
            ws.send(
              JSON.stringify({
                topic: `portfolio-im-variable`,
                action: 'unsubscribe',
              }),
            );
            ws.send(
              JSON.stringify({
                topic: `portfolio-im-fixed`,
                action: 'unsubscribe',
              }),
            );
          }

          ws.send(
            JSON.stringify({
              topic: contestId
                ? `fantasy-private-portfolio`
                : `private-portfolio`,
              action: 'unsubscribe',
            }),
          );
        } catch (e) {}
      }
    };
  }, [wsConnected, ws, isAppLogin, contestId]);
}
